export enum StanbyMode {
  SENSOR = 'Sensor',
  ALWAYS_ON = 'AlwaysOn',
  ALWAYS_OFF = 'AlwaysOff',
}
